import React from 'react';
import { Calendar, Users, Trophy, Lightbulb } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { familyData } from '../mock';

const History = () => {
  const timelineEvents = [
    {
      year: "1978",
      title: "Fundação",
      description: `${familyData.founder} funda a primeira empresa familiar em Goiânia, começando com uma visão empreendedora sólida.`,
      icon: Users
    },
    {
      year: "1985",
      title: "Primeira Expansão",
      description: "Consolidação no mercado local e início da diversificação dos negócios familiares.",
      icon: Trophy
    },
    {
      year: "1995",
      title: "Crescimento Industrial",
      description: "Entrada no setor industrial com a Montreal Indústria, expandindo para novos mercados.",
      icon: Lightbulb
    },
    {
      year: "2010",
      title: "Grupo Consolidado",
      description: "Formação oficial da holding, unificando todas as empresas sob uma gestão estratégica.",
      icon: Calendar
    }
  ];

  return (
    <section id="historia" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            {familyData.story.title}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            {familyData.story.content}
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-slate-200"></div>
          
          <div className="space-y-12">
            {timelineEvents.map((event, index) => {
              const Icon = event.icon;
              return (
                <div 
                  key={event.year} 
                  className={`flex items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} animate-in fade-in-0 duration-1000`}
                  style={{ animationDelay: `${index * 200}ms` }}
                >
                  {/* Content Card */}
                  <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                    <Card className="hover:shadow-lg transition-all duration-300 transform hover:scale-105">
                      <CardContent className="p-6">
                        <div className="flex items-start space-x-4">
                          <div className="flex-shrink-0">
                            <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center">
                              <Icon className="w-6 h-6 text-slate-700" />
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center space-x-2 mb-2">
                              <span className="text-2xl font-bold text-slate-900">{event.year}</span>
                              <div className="h-px bg-slate-300 flex-1"></div>
                            </div>
                            <h3 className="text-xl font-semibold text-slate-800 mb-2">{event.title}</h3>
                            <p className="text-slate-600 leading-relaxed">{event.description}</p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>

                  {/* Timeline Node */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-slate-800 rounded-full border-4 border-white shadow-lg z-10"></div>
                  
                  {/* Spacer for opposite side */}
                  <div className="hidden lg:block w-5/12"></div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Values Section */}
        <div className="mt-20">
          <h3 className="text-2xl font-bold text-slate-900 text-center mb-8">Nossos Valores</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {familyData.story.values.map((value, index) => (
              <Card 
                key={index} 
                className="text-center hover:shadow-lg transition-all duration-300 transform hover:scale-105 animate-in fade-in-0 duration-1000"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <CardContent className="p-6">
                  <div className="w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <Trophy className="w-6 h-6 text-slate-700" />
                  </div>
                  <p className="text-slate-700 font-medium">{value}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;